import { useMedia } from 'react-use';
import { useTranslations } from 'next-intl';
import { SliderCard as SliderCardType } from '@silvertours/back-domain-page';
import { analytics, Carousel, SliderCard } from '@silvertours/front-entities';
import { Theme } from '@silvertours/front-shared';
import { Container, Wrapper } from './MarketingSlider.styles';

export type Props = {
  isModernStage?: boolean;
  sliderCards?: SliderCardType[];
};

const MarketingSlider = ({ isModernStage = false, sliderCards }: Props) => {
  const CarouselContainer = Container;
  const t = useTranslations('features.marketingSlider');
  const isMobile = useMedia(
    `(max-width: ${Theme.getBreakpoint('xl')}px)`,
    true,
  );

  const isSmall = useMedia(`(max-width: ${Theme.getBreakpoint('sm')}px)`, true);

  const visibleItemsAmount = isMobile ? 1 : 3;

  const handleSlideChange = (direction: 'forward' | 'backward') => {
    analytics.generic.trackMarketingSliderButtonClick(direction);
  };

  const handleSlideDrag = () => {
    analytics.generic.trackMarketingSliderDrag();
  };

  const handleMousewheel = () => {
    analytics.generic.trackMarketingSliderMouseWheel();
  };

  if (!sliderCards?.length) {
    return null;
  }

  return (
    <Wrapper id="cardsSlider" $isModernStage={isModernStage}>
      <CarouselContainer
        $isModernStage={isModernStage}
        as={Carousel}
        hasItemsToReveal={sliderCards.length > visibleItemsAmount}
        showSlideBackground={false}
        prevText={t('prevText')}
        nextText={t('nextText')}
        label={t('title')}
        onSlideChange={handleSlideChange}
        onSlideDrag={handleSlideDrag}
        onMouseWheel={handleMousewheel}
      >
        {sliderCards.map(card => (
          <SliderCard
            key={card.title}
            text={card.text}
            image={card.image}
            linkText={card.linkText}
            linkHref={card.href}
            isSmall={isSmall}
            title={card.title}
          />
        ))}
      </CarouselContainer>
    </Wrapper>
  );
};

export { MarketingSlider };
